module.exports = __webpack_public_path__ + "static/media/52106851_2452979768110533_3402555168716226560_o.b3d21575.jpg";